<template>
  <div class="container">
    <div class="common-header-wrap">
      <mt-header title="举报" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>
    <div class="body">
      <div class="rep_p">
        <span class="rep_title">举报内容</span>
        <textarea
        ref="autoTextArea"
        @input="adjustTextAreaHeight"
          placeholder="请输入举报内容"
          v-model="content"
          name="report_cont"
          cols="28"
          rows="2"
        ></textarea>
      </div>
      <div class="rep_p">
        <span class="rep_title">举报凭证</span>
        <input
          type="file"
          @change="handleFileChange"
          name="image"
          accept="image/*"
          hidden
          ref="fileInput"
        />
        <div v-if="yesup" class="upload-btn" @click="openFileInput">
          <span>上传图片</span>
        </div>
        <div v-else class="upload-btn2">
          <span>上传图片</span>
        </div>
      </div>
      <!-- 图片显示 -->
      <div class="picture_body">
        <div
          class="picture_item"
          v-for="(item, index) in imageList"
          v-bind:key="index"
        >
          <img v-bind:src="item" />
        </div>
      </div>

      <div class="bottom_p">
        <div class="tijiao" @click="submit">提交</div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { upreport } from '../../../api/report'
import { Toast } from 'mint-ui'

export default {
  data () {
    return {
      content: '', //文字内容
      selectedImage: null,
      imageList: [], //显示图片
      yesup: true //小于3张,可以继续选择
      ,textAreaContent: "",
    }
  },
  methods: {
    adjustTextAreaHeight() {
      const textArea = this.$refs.autoTextArea;
      textArea.style.height = "auto"; // 重置高度为自动以便计算新高度
      textArea.style.height = textArea.scrollHeight + "px"; // 设置高度为内容的滚动高度
    },
    openFileInput () {
      // 触发文件输入框的点击事件
      this.$refs.fileInput.click()
    },
    handleFileChange (event) {
      let that = this
      that.selectedImage = event.target.files[0]
      console.log(that.selectedImage)
      const form = new FormData()
      form.append('file', that.selectedImage)
      const apiUrl = env.API_HOST + '/Padindex/slh_swfupload'
      axios
        .post(apiUrl, form)
        .then(response => {
          console.log('成功响应:', response.data)
          that.imageList.push(response.data.file_url)
          if (that.imageList.length >= 3) {
            that.yesup = false
          }
          console.log('that.imageList', that.imageList)
        })
        .catch(error => {
          console.error('请求失败:', error)
        })
    },
    submit () {
      // $complain_content = input('param.complain_content', null); //举报内容
      // $complain_pic = input('param.complain_pic', null); //举报图片
      // $complain_from = input('param.complain_from', 1);小程序 3,h5 2,PC 1
      let complain_from = 2
      let complain_content = this.content
      let complain_pic = this.imageList.join(',')

      // console.log(complain_from,complain_content, complain_pic)
      if (complain_content) {
        upreport(complain_from, complain_content, complain_pic)
          .then(res => {
            // console.log(res, '111111')
            Toast(res.message)
          })
          .catch(function (error) {
            Toast(error.message)
          })
      } else {
        Toast('请输入举报内容')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.common-score-wrapper .back {
  display: block;
}
.container {
  background-color: #fff;
  min-height: 100vh; /* 设置最小高度为视口高度 */
}
.body {
  padding: 1rem;
}
.rep_p {
  padding: 1rem 0;
  display: flex;
  border-bottom: 1px solid #999;
  .rep_title {
    width: 34%;
    color: #999;
    font-size: 0.8rem;
  }
}
.bottom_p {
  padding: 1rem;
  text-align: center;
  .tijiao {
    height: 1.8rem;
    line-height: 1.8rem;
    color: #fff;
    font-size: 0.8rem;
    background-color: #ee0a24;
    border-radius: 0.5rem;
  }
}
.upload-btn {
  background-color: #ee0a24;
  color: #fff;
  display: inline-block;
  padding: 0.3rem;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  font-size: 0.7rem;
}
.upload-btn2 {
  background-color: #c85865;
  color: #fff;
  display: inline-block;
  padding: 0.3rem;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  font-size: 0.7rem;
}
textarea {
  border: none;
  outline: none;
  font-size: 0.7rem
}
.picture_body {
  display: flex;
  justify-content: space-evenly;
  margin-top: 1rem;
  height: 5rem;
  width: 100%;
  .picture_item {
    width: 25%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
